module.exports = __webpack_public_path__ + "img/9788996940302.7a41603d.jpg";